import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_workplace_rules_made_visible_in_fac_common_areas_eg_canteen'

export const dataPointDefinition = {
  retracedId: 'are_workplace_rules_made_visible_in_fac_common_areas_eg_canteen',
  name: 'Are workplace rules made visible in facility common areas (e.g. canteen, locker rooms, toilets, etc.) in all languages spoken in the facility?',
  description:
    'The intent of this question is to understand if workers can see the workplace rules and understand them. ',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'rh-emp-3',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 5930,
  sectionId: '2.2.4.3',
  impactArea: 'General Work Environment',
  impactAreaId: 'GENERAL_WORK_ENVIRONMENT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
